import { toastr } from 'react-redux-toastr';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import {
  CLEAR_SALES_SESSION_DEBIT_NOTES,
  FLAG_GETTING_SALES_SESSION_DEBIT_NOTES,
  GET_SALES_SESSION_DEBIT_NOTES,
} from '../types';
import { isErrorResponse } from '../../utils/error-handlers';
import { generateSalesSessionDebitNotesEndpoint } from '../../config/endpoints';

const flagGettingSalesSessionDebitNotes = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_SALES_SESSION_DEBIT_NOTES,
    payload: flag,
  });

const getSalesSessionDebitNotes =
  async ({ salesSessionId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingSalesSessionDebitNotes(true));
      const url = generateSalesSessionDebitNotesEndpoint(salesSessionId);
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const debitNotes = await response.json();
      await dispatch({
        type: GET_SALES_SESSION_DEBIT_NOTES,
        payload: debitNotes,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingSalesSessionDebitNotes(false));
    }
  };

const clearSalesSessionDebitNotes = () => (dispatch) =>
  dispatch({
    type: CLEAR_SALES_SESSION_DEBIT_NOTES,
  });

export { getSalesSessionDebitNotes, clearSalesSessionDebitNotes };
